import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nService } from '../../services/i18n.service';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent implements OnInit {
  stats = {
    experience: (new Date()).getFullYear() - 2011,
    projects: 50,
    clients: 20
  };

  coreTechnologies = [
    'C#', '.NET Core', '.NET Framework',
    'MSSQL Server', 'MySQL', 'PostgreSQL',
    'Azure', 'AWS', 'GCP',
    'Docker', 'Kubernetes',
    'Bootstrap',
    'Angular', 'ReactJS',
    'JavaScript', 'TypeScript'
  ];

  constructor(public i18n: I18nService) {}

  ngOnInit(): void {
    this.i18n.initializeLanguage();
  }
}
